import z from "zod";

export const lastReviewSchema = z.object({
  state: z.enum(['approved', 'disapproved']),
  description: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
});

export type LastReviewValidationSchema = z.infer<typeof lastReviewSchema>;
